import { Component, output, input, signal } from '@angular/core';
import { Client } from '@mira-avant/mtlibs';
import { ClientService } from '../../../../services/client.service';
import { Subscription } from 'rxjs';
import { AngularModule } from '../../../../modules/angular.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ListComponent } from '../list/list.component';

@Component({
	selector: 'app-client-selector',
	standalone: true,
	imports: [AngularModule, ZorroModule, ListComponent],
	templateUrl: './client-selector.component.html',
	styleUrl: './client-selector.component.scss',
})
export class ClientSelectorComponent {
	readonly onSelect = output<Client>();
	readonly selectedUuid = input<string | undefined>();

	readonly loading = signal<boolean>(true);
	readonly clients = signal<Client[]>([]);

	private sub: Subscription | undefined;

	constructor(public clientService: ClientService) {}

	ngOnInit(): void {
		this.sub = this.clientService.clients$.subscribe(clients => {
			this.clients.set(clients ?? []);
			this.loading.set(false);
		});
	}

	public select(client: Client): void {
		this.onSelect.emit(client);
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}
}
